import { Label } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { Select } from 'antd';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { MODULE_BENEFIT_ORDER, MODULE_PAYROLL_ORDER } from '../../../constants/modules';
import * as CompanyRepository from '../../../services/repository/companyRepository';
import MultiSelect from '../../molecules/MultiSelect';

const { Option } = Select;

function SelectRelacionamento({
  value = [],
  onChange,
  relacionamentos: relacionamentosParam = [],
  module = undefined,
  placeholder = 'Selecione...',
  disabled = false,
  showLabel = true,
}) {
  const criteria = useMemo(() => (module ? { modules: [module] } : {}), [module]);
  const { isPending, data: fetchedData } = CompanyRepository.useAccessibleCompanies(criteria);

  const relacionamentos = useMemo(() => {
    if (relacionamentosParam && relacionamentosParam.length > 0) {
      return relacionamentosParam.map((rel) => (typeof rel === 'string' ? { id: rel, name: rel } : rel));
    }
    const uniqueNames = [...new Set((fetchedData || []).map((c) => c.relacionamento).filter(Boolean))];
    return uniqueNames.map((name) => ({ id: name, name }));
  }, [relacionamentosParam, fetchedData]);

  const areAllSelected = value.length === relacionamentos.length && relacionamentos.length > 0;

  const renderOptions = () =>
    relacionamentos.map((rel) => (
      <Option
        key={rel.id}
        value={rel.id}
      >
        {rel.name}
      </Option>
    ));

  const multiSelect = (
    <MultiSelect
      placeholder={placeholder}
      loading={isPending}
      disabled={disabled}
      value={value}
      // Arrow function ignora o 2º argumento (option object) do Ant Design,
      // garantindo que o callback propague apenas o array de strings (value).
      onChange={(v) => onChange(v)}
      areAllSelected={areAllSelected}
      onChangeAllSelected={(checked) => onChange(checked ? relacionamentos.map((r) => r.id) : [])}
    >
      {renderOptions()}
    </MultiSelect>
  );

  if (!showLabel) return multiSelect;

  return <Label label="Relacionamento">{multiSelect}</Label>;
}

SelectRelacionamento.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  relacionamentos: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape()])),
  module: PropTypes.oneOf([MODULE_PAYROLL_ORDER, MODULE_BENEFIT_ORDER]),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  showLabel: PropTypes.bool,
};

export default SelectRelacionamento;
